<div class="container-fluid">
    <div class="header-container">
        <div class="header-container">
            <div class="loading" style="margin-top: 60px" *ngIf="loading">
                <div class="loader"></div>
            </div>
        </div>
    </div>
    <div *ngIf="rideForm">
        <div class="content">
            <h5>{{ 'bikeshop.shop_rides.ride_details' | translate }}</h5>
            <form [formGroup]="rideForm" onkeydown="return event.key != 'Enter';">
                <div class="row margin-top-8">
                    <div class="col-md-2 label"
                         [ngClass]="{'red': !rideForm.value.name}">{{ 'bikeshop.shop_rides.ride_name' |
                        translate }}:
                    </div>
                    <div class="col-md-6">
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="fa fa-clipboard"></i></span>
                            <input type="text" pInputText formControlName="name"
                                   placeholder="{{ 'general.name' | translate }}"/>
                        </div>
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-2 label">
                        {{ 'bikeshop.shop_rides.ride_description' | translate }}:
                    </div>
                    <div class="col-md-10">
                        <textarea [rows]="2" pInputTextarea formControlName="description"></textarea>
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-2 label" [ngClass]="{'red': !rideForm.value.selectedRideType}">{{
                        'bikeshop.shop_rides.ride_type' | translate }}:
                    </div>
                    <div class="col-md-10 default">
                        <div class="p-inputgroup">
                            <p-selectButton [options]="rideTypes" [disabled]="ride.id"
                                            formControlName="selectedRideType"
                                            (onChange)="ride.groups = []">
                            </p-selectButton>
                        </div>
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-2 label"
                         [ngClass]="{'red': !rideForm.value.date}">{{ 'bikeshop.shop_rides.ride_date' |
                        translate }}:
                    </div>
                    <div class="col-md-4">
                        <div class="p-inputgroup">
              <span class="p-inputgroup-addon">
                <i class="fa fa-calendar-check-o"></i>
              </span>
                            <p-calendar dateFormat="yy-mm-dd" formControlName="date" [readonlyInput]="true"
                                        [minDate]="minDate">
                            </p-calendar>
                        </div>
                    </div>
                    <div class="col-md-2 label"
                         [ngClass]="{'red': !rideForm.value.time}">{{ 'bikeshop.shop_rides.start_time' |
                        translate }}:
                    </div>
                    <div class="col-md-4">
                        <div class="p-inputgroup">
              <span class="p-inputgroup-addon">
                <i class="fa fa-clock-o"></i>
              </span>
                            <p-calendar dateFormat="HH:mm" formControlName="time" [readonlyInput]="true"
                                        [timeOnly]="true">
                            </p-calendar>
                        </div>
                    </div>
                </div>

                <div class="row margin-top-8" *ngIf="!loading && !ride.id">
                    <div class="col-md-2 label">{{ 'bikeshop.shop_rides.repeat_event' | translate }}:</div>
                    <div class="col-md-2 value">
                        <p-inputSwitch formControlName="repeat"></p-inputSwitch>
                    </div>
                </div>
                <div class="repeating" *ngIf="rideForm.controls['repeat'].value">

                    <div class="row margin-top-8">
                        <div class="col-md-2 label">{{ 'bikeshop.shop_rides.repeat_weeks' | translate }}:</div>
                        <div class="col-md-4 flex">
                            <div style="flex: 1;align-self: center;">
                                <p-slider [max]="8" [min]="1" [step]="1" formControlName="repeatWeeks"></p-slider>
                            </div>
                        </div>
                        <div
                                class="col-md-4 flex label">{{ 'bikeshop.shop_rides.weeks' | translate : {repeatWeek: rideForm.value.repeatWeeks} }}</div>
                    </div>

                    <div class="row margin-top-16" *ngIf="rideForm.controls['repeat'].value">
                        <div class="col-md-2 label">{{ 'bikeshop.shop_rides.repeat_every' | translate }}:</div>
                        <div class="col-md-10 weekdays">
                            <p-checkbox [(ngModel)]="weekDays.Monday" [binary]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        label="Monday">
                            </p-checkbox>
                            <p-checkbox [(ngModel)]="weekDays.Tuesday" [binary]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        label="Tuesday">
                            </p-checkbox>
                            <p-checkbox [(ngModel)]="weekDays.Wednesday" [binary]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        label="Wednesday">
                            </p-checkbox>
                            <p-checkbox [(ngModel)]="weekDays.Thursday" [binary]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        label="Thursday">
                            </p-checkbox>
                            <p-checkbox [(ngModel)]="weekDays.Friday" [binary]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        label="Friday">
                            </p-checkbox>
                            <p-checkbox [(ngModel)]="weekDays.Saturday" [binary]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        label="Saturday">
                            </p-checkbox>
                            <p-checkbox [(ngModel)]="weekDays.Sunday" [binary]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        label="Sunday">
                            </p-checkbox>
                        </div>
                    </div>
                    <div class="row margin-top-16"
                         *ngIf="rideForm.controls['repeat'].value && rideForm.controls['date'].valid">
                        <div class="col-md-2 label">{{ 'bikeshop.shop_rides.repeat_until' | translate }}:</div>
                        <div class="col-md-4">
                            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="fa fa-calendar-check-o"></i>
                </span>
                                <p-calendar dateFormat="yy-mm-dd" [minDate]="rideForm.controls['date'].value"
                                            formControlName="endDate"
                                            [readonlyInput]="true"></p-calendar>
                            </div>
                        </div>
                    </div>
                </div>

                <!--<div class="row margin-top-8">
                  <div class="col-md-2 label">*Role call:</div>
                  <div class="col-md-4">
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon">
                        <i class="fa fa-clock-o"></i>
                      </span>
                      <p-dropdown class="full-width" [options]="roleOptions" formControlName="roleCall"
                        placeholder="Roll call options"></p-dropdown>
                    </div>
                  </div>
                </div>-->

                <div class="row margin-top-8">
                    <div class="col-md-2 label" [ngClass]="{'red': !rideForm.value.location}">{{
                        'bikeshop.shop_rides.ride_location' | translate }}:
                    </div>
                    <div class="col-md-10">
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="fa fa-map-marker"></i></span>
                            <input type="text" pInputText formControlName="location"
                                   placeholder="{{ 'bikeshop.shop_rides.location_description' | translate }}"/>
                        </div>
                    </div>
                </div>

                <div class="row margin-top-8">
                    <div class="col-md-2 label">{{ 'bikeshop.shop_rides.ride_active' | translate }}:</div>
                    <div class="col-md-2 value">
                        <p-inputSwitch formControlName="active"></p-inputSwitch>
                    </div>
                </div>
                <!-- <div class="row margin-top-8">
                  <div class="col-md-2 label">Make Event Public:</div>
                  <div class="col-md-10 value">
                    <div>
                      <p-inputSwitch formControlName="public"></p-inputSwitch>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="row">
                  <div class="col-md-2 label"></div>
                  <div class="col-md-10 value">
                    <div>
                      <small>***When you make an event public, users who do not belong to your club will be able to join the
                        event.</small>
                    </div>
                  </div>
                </div> -->

            </form>
        </div>


        <div class="content" *ngIf="ride && ride.groupAttendees && ride.groupAttendees.length > 0">

            <div class="flex" style="justify-content: space-between;">
                <div>
                    <h5>{{'bikeshop.shop_rides.attendees' | translate }}</h5>
                </div>
            </div>

            <div *ngFor="let group of ride.groupAttendees" class="attendee-group">
                <div>{{group.groupName}} ({{group.attendees.length}})</div>
                <ul>
                    <li *ngFor="let attendee of group.attendees">{{attendee.rider}} - {{attendee.email}}</li>
                </ul>
            </div>
        </div>


        <div class="content">

            <div class="row" *ngIf="posterImg">
                <div class="col-md-12 margin-bottom-16">
                    <div class="poster-image"
                         [ngStyle]="{'background-image': 'url('+posterImg+'), linear-gradient(0deg, white 0%, white 100%)'}"></div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <button pButton class="p-button full-width"
                            label="{{'bikeshop.shop_rides.upload_poster_image' | translate}}"
                            (click)="posterUpload.click()"></button>
                    <input #posterUpload type="file" style="display: none" (change)="posterUploader($event)">
                </div>
            </div>

        </div>

        <div class="content" #manageGroupTarget>
            <div class="flex" style="justify-content: space-between;">
                <div>
                    <h5 [ngClass]="{'red': ride.groups === undefined || ride.groups === null || ride.groups.length === 0}">{{
                        'bikeshop.shop_rides.ride_groups' | translate }}</h5>
                    <p>{{ 'bikeshop.shop_rides.ride_groups_description' | translate }}</p>
                </div>
                <div class="footer">
                    <button pButton class="alternate" label="{{ 'bikeshop.shop_rides.add_new_group' | translate }}"
                            (click)="manageGroup($event, groupPanel, null, manageGroupTarget)"></button>
                </div>
            </div>
            <div class="status-container">
                <div *ngFor="let group of listRideGroups()">
                    <div class="card-select-group"
                         [ngClass]="{'selected': ride.groups && ride.groups.indexOf(group.id) > -1}">
                        <div class="group-content" (click)="toggleGroupSelection(group)">
                            <div class="header">
                                <div class="group">{{ group.name }}</div>
                            </div>
                            <div class="speed">{{ group.minimumSpeed }} {{speedUnit}} {{'bikeshop.shop_rides.min' | translate}} </div>
                            <div class="speed">{{ group.averageSpeed }} {{speedUnit}} {{'bikeshop.shop_rides.avg' | translate}} </div>
                            <!-- <div class="attendance">
                            <div>Attendance</div>
                            <div>{{group.Attendees ? (group.Attendees.length + ' going') : 'N/A'}}</div>
                          </div> -->
                        </div>
                        <div class="footer">
                            <button pButton label="{{ 'general.edit' | translate }}" class="alternate full-width"
                                    (click)="manageGroup($event, groupPanel, group, manageGroupTarget)"></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no-groups"
                 *ngIf="listRideGroups().length === 0">{{ 'bikeshop.shop_rides.no_ride_groups' | translate :
                {rideType: rideForm.value.selectedRideType}
                }}</div>

            <p-overlayPanel #groupPanel [dismissable]="false" [showCloseIcon]="true">
                <div style="width: 450px; padding-top: 40px">
                    <div class="row">
                        <div class="col-md-5 label">{{ 'bikeshop.shop_rides.group_name' | translate }}:</div>
                        <div class="col-md-7">
                            <input type="text" pInputText [(ngModel)]="groupUpdate.name"/>
                        </div>
                    </div>
                    <div class="row margin-top-16">
                        <div class="col-md-5 label">{{ 'bikeshop.shop_rides.average_group_speed' | translate }}:</div>
                        <div class="col-md-5">
                            <div class="margin-top-8">
                                <p-slider [max]="50" [min]="1" [step]="1"
                                          [(ngModel)]="groupUpdate.averageSpeed"></p-slider>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div>
                                {{groupUpdate.averageSpeed}} {{speedUnit}}
                            </div>
                        </div>
                    </div>
                    <div class="row margin-top-16">
                        <div class="col-md-5 label">{{ 'bikeshop.shop_rides.minimum_group_speed' | translate }}:</div>
                        <div class="col-md-5">
                            <div class="margin-top-8">
                                <p-slider [min]="1" [max]="groupUpdate.averageSpeed" [step]="1"
                                          [(ngModel)]="groupUpdate.minimumSpeed">
                                </p-slider>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div>
                                {{groupUpdate.minimumSpeed}} {{speedUnit}}
                            </div>
                        </div>
                    </div>
                    <div class="row margin-top-16">
                        <div class="col-md-6">
                            <button *ngIf="groupUpdate.id" pButton class="full-width"
                                    label="{{ 'bikeshop.shop_rides.remove_group' | translate }}"
                                    (click)="removeGroup(groupPanel)"></button>
                        </div>
                        <div class="col-md-6">
                            <button pButton class="full-width"
                                    label="{{ 'bikeshop.shop_rides.save_group' | translate }}"
                                    [disabled]="!groupUpdate.name || groupUpdate.averageSpeed === 0 || groupUpdate.minimumSpeed === 0"
                                    (click)="saveGroup(groupPanel)"></button>
                        </div>
                    </div>
                </div>
            </p-overlayPanel>
        </div>

        <div class="content" *ngIf="ride.id && rideGroups && rideGroups.length > 0">
            <div>
                <h5>{{
                    'bikeshop.shop_rides.ride_images' | translate }}</h5>
                <p>{{ 'bikeshop.shop_rides.ride_images_info' | translate }}</p>
            </div>

            <div class="ride-images">
                <div *ngFor="let image of mediaImages; let i = index">
                    <img [src]="image.mediaURL"/>
                    <div class="remove-image" (click)="removeImage(i, image)"><span class="fa fa-times"></span></div>
                </div>
            </div>

            <div class="row margin-top-16">
                <div class="col-md-4">
                    <button pButton class="p-button full-width"
                            label="{{'bikeshop.shop_rides.upload_images' | translate}}"
                            (click)="imagesUpload.click()"
                            [disabled]="!(ride.groups && ride.groups.length > 0)"></button>
                    <input #imagesUpload type="file" multiple style="display: none"
                           (change)="uploadMediaImages($event)">
                </div>
            </div>

        </div>


        <div class="content">
            <div class="flex" style="justify-content: space-between;">
                <h5
                        [ngClass]="{'red': ride.bikeShopRideRouteID === undefined || ride.bikeShopRideRouteID === null || ride.distance === null || ride.distance === undefined || ride.distance === 0}">
                    {{ 'bikeshop.shop_rides.ride_route' | translate }}</h5>
                <button #uploadGPXButton pButton class="alternate"
                        label="{{'bikeshop.shop_rides.upload_gpx' | translate}}"
                        (click)="fileUpload.click()"></button>
                <input #fileUpload type="file" style="display: none" (change)="uploadGPX($event, uploadGPXButton)"
                       accept=".gpx">
            </div>
            <div class="ride-distance-explanation" [ngClass]="{'red': !ride.distance }">
                {{ 'bikeshop.shop_rides.ride_distance_explanation' | translate }}
            </div>
            <div class="route-list-container">
                <div *ngFor="let route of rideRoutes" class="route-list row">
                    <div class="col-md-6">
                        <p-radioButton name="routes" value="{{ route.id }}" label="{{ route.routeName }}"
                                       [(ngModel)]="selectedRoute" (click)="getRideRoute(route.id)"></p-radioButton>
                    </div>
                    <div class="col-md-2">{{route.distance | number : '.0-0'}} {{distanceUnit}}</div>
                    <div class="col-md-2">{{route.elevationGain | number : '.0-0'}} {{elevationUnit}}</div>
                    <div class="col-md-1">
                        <span pTooltip="{{'bikeshop.shop_rides.delete_route' | translate}}"
                                                tooltipPosition="left" class="fa fa-trash-o"
                                                (click)="deleteRoute(route)"></span>
                    </div>
                    <div class="col-md-1">
                        <div *ngIf="downloadLoading">
                            <div class="downloadgpx loader"></div>
                        </div>

                        <div *ngIf="!downloadLoading">
                            <span pTooltip="{{'bikeshop.shop_rides.download_route' | translate}}"
                            tooltipPosition="left" class="fa fa-download"
                            (click)="downloadRoute(route)"></span>
                        </div>                 
                    </div>
                </div>
            </div>

            <div class="distance-container">
                <div class="row">
                    <div class="col-md-2 label">*{{ 'bikeshop.shop_rides.ride_distance' | translate }}:</div>
                    <div class="col-md-3">
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="fa fa-road"></i></span>
                            <input type="number" pInputText [(ngModel)]="ride.distance"
                                   placeholder="{{ 'bikeshop.shop_rides.ride_distance' | translate }}"
                                   [disabled]="selectedRoute"/>
                        </div>
                    </div>
                    <div class="col-md-2 label" style="margin-left: -24px">{{distanceUnit}}</div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="row">
                <div class="col-md-3">
                    <button *ngIf="ride.id" pButton class="p-button alternate full-width" (click)="cancel()"
                            label="{{ 'general.cancel' | translate }}">
                    </button>
                </div>
                <div class="col-md-6"></div>
                <div class="col-md-3">
                    <button pButton class="p-button full-width" (click)="saveRide(rideForm.value)"
                            [disabled]="!checkValidation() || buttonDisabled"
                            label="{{(buttonDisabled ? 'general.busy_please_wait' : 'bikeshop.shop_rides.save_ride') | translate }}">
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<p-confirmDialog key="shop_ride"></p-confirmDialog>
<p-dialog #routeNamePrompt title="{{'bikeshop.shop_rides.route_name' | translate}}" [(visible)]="showRouteNamePrompt"
          [style]="{width: '450px'}">
    <div class="row">
        <div class="col-md-4">{{ 'bikeshop.shop_rides.route_name' | translate }}</div>
        <div class="col-md-8"><input type="text" pInputText [(ngModel)]="routeName"/></div>
    </div>
    <div class="row margin-top-16">
        <div class="col-md-4"></div>
        <div class="col-md-8">
            <button pButton clas="fill-width" [disabled]="!routeName"
                    label="{{ 'bikeshop.shop_rides.save_route' | translate }}"
                    (click)="saveRoute($event, routeNamePrompt)"></button>
        </div>
    </div>
</p-dialog>
